/**
 * src/services/onboardingService.js
 * All API calls for the 3-step onboarding flow.
 * Uses axios instance from api.js (auto-attaches token if present).
 */
import api from "../lib/api";

// GET /api/auth/onboarding/info?token=
// Called on mount of each step to validate token + get role/step info
const getOnboardingInfo = async (token) => {
  const response = await api.get(`/auth/onboarding/info?token=${token}`);
  return response.data;
  // Returns: { success, data: { email, role, designation, dateOfJoining,
  //            onboardingStep, requiresDocuments } }
};

// POST /api/auth/onboarding/profile — Step 1
// Body: token + personal details
const submitProfile = async (profileData) => {
  const response = await api.post("/auth/onboarding/profile", profileData);
  return response.data;
  // Returns: { success, message, data: { onboardingStep: 1 } }
};

// POST /api/auth/onboarding/documents — Step 2
// Body: FormData (multipart) with token + files
const submitDocuments = async (formData) => {
  const response = await api.post("/auth/onboarding/documents", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
  // Returns: { success, message, data: { onboardingStep: 2 } }
};

// POST /api/auth/onboarding/set-password — Step 3
// Body: { token, password }
const submitSetPassword = async ({ token, password }) => {
  const response = await api.post("/auth/onboarding/set-password", {
    token,
    password,
  });
  return response.data;
  // Returns: { success, message, data: { name, role, dateOfJoining,
  //            employeeId?, designation? } }
};

const onboardingService = {
  getOnboardingInfo,
  submitProfile,
  submitDocuments,
  submitSetPassword,
};

export default onboardingService;
